import {useMemo} from 'react';
import {ICleanUp} from '../models/cleanUp';

export const useCollectorName = (createdBy?: ICleanUp['created_by']) => {
    const collectorName = useMemo(() => {
        if (!createdBy) return '';
        return `${createdBy.first_name} ${createdBy.last_name}`;
    }, [createdBy]);

    return [collectorName, true] as const;
};
